import { post } from '@tencent/pmd-network';
import { GoodsConfigInfo } from '@tencent/pmd-config/lib/goods';
import { ConfigInfo } from '@tencent/pmd-config/lib/project';
import { UserInfo } from '@tencent/pmd-tools/lib/user-info';
import { GAME_LIFE } from '@tencent/pmd-tools/lib/game';

const postGetBindRelation = function (srcOpenid) {
  return new Promise((resolve, reject) => {
    const reqData = {
      src_openid: srcOpenid,
      channel_id: 'tip',
    };
    post({
      url: GoodsConfigInfo.instance.getBindRelationUrl
        || '/merc.merccgi.accountBind.accountBind/GetBindRelation',
      cloudCGI: true,
      showMsgToast: false,
      reqData,
      oldCGIPostJsonObject: true,
    }).then((response) => {
      if (response.dst_nickname) {
        resolve(response);
      } else {
        reject(response);
      }
    })
      .catch((error) => {
        reject(error);
      });
  });
};

const postSetBindRelation = function (bindType, dstOpenid, srcOpenid, accessToken) {
  return new Promise((resolve, reject) => {
    const reqData = {
      bind_type: bindType,
      dst_openid: dstOpenid,
      src_openid: srcOpenid,
      channel_id: 'tip',
      accessToken,
    };
    post({
      url: GoodsConfigInfo.instance.setBindRelationUrl
        || '/merc.merccgi.accountBind.accountBind/SetBindRelation',
      cloudCGI: true,
      showMsgToast: false,
      reqData,
      oldCGIPostJsonObject: true,
    }).then((response) => {
      resolve(response);
    })
      .catch((error) => {
        reject(error);
      });
  });
};

const postGetBindToken = function () {
  return new Promise((resolve, reject) => {
    post({
      url: GoodsConfigInfo.instance.getBindTokenUrl
        || '/merc.merccgi.accountBind.accountBind/GetBindToken',
    }).then((response) => {
      resolve(response);
    })
      .catch((error) => {
        reject(error);
      });
  });
};

function postSetUserAndBrandRelation(reqData) {
  reqData.uid = app.tip_uid || UserInfo.tipUid();
  return new Promise((resolve, reject) => {
    post({
      reqData,
      showMsgToast: false,
      command: '/merc.merccgi.accountBind.accountBind/SetUserAndBrandRelation',
    }).then((response) => {
      resolve(response);
    })
      .catch((error) => {
        reject(error);
      });
  });
}

function postUpdateUserPhone(reqData) {
  reqData.uid = app.tip_uid || UserInfo.tipUid();
  return new Promise((resolve, reject) => {
    post({
      reqData,
      showMsgToast: true,
      url: GoodsConfigInfo.instance.updateUserPhone
      || '/merc.merccgi.accountBind.accountBind/UpdateUserPhone',
    }).then((response) => {
      resolve(response);
    })
      .catch((error) => {
        reject(error);
      });
  });
}

function postSendTelMsgCode(reqData) {
  if (!reqData.gid || reqData.gid === 0 || reqData.gid === GAME_LIFE) {
    reqData.gid = app.tip_gid || ConfigInfo.instance.getTipGid();
  }
  return new Promise((resolve, reject) => {
    post({
      reqData,
      showMsgToast: true,
      url: GoodsConfigInfo.instance.sendTelMsgCodeUrl
        || '/pmdtrpc.commcgi.tipcgi.tipcgi/SendTelMsgCode',
    }).then((response) => {
      resolve(response);
    })
      .catch((error) => {
        reject(error);
      });
  });
}

/**
 * 发送短信验证码--防水墙版本
 * @description https://git.woa.com/itrpcprotocol/pmdtrpc/commcgi/blob/master/tipcgi/tipcgi.proto#L15
 * @param {object} reqData 请求参数 { mobile: 手机号, gid: 331, app_id: 渠道号（咨询后台）, ticket: 读取滑动验证结果, rand_str: 读取滑动验证结果 }
 * @returns
 *
 */
function postSendTelMsgCodeWithWaterProof(params) {
  const reqData = {
    ...params,
    gid: params.gid || app.tip_gid || ConfigInfo.instance.getTipGid(),
  };
  return new Promise((resolve, reject) => {
    post({
      reqData,
      showMsgToast: true,
      url: '/pmdtrpc.commcgi.tipcgi.tipcgi/SendTelMsgCodeWithWaterProof',
    }).then((response) => {
      resolve(response);
    })
      .catch((error) => {
        reject(error);
      });
  });
}

function postGetLottCondAndWritting() {
  const reqData = {};
  reqData.gid = app.tip_gid || ConfigInfo.instance.getTipGid();
  return new Promise((resolve, reject) => {
    post({
      reqData,
      showMsgToast: false,
      url: '/merc.merccgi.acts.acts/GetLottCondAndWritting',
    }).then((response) => {
      resolve(response);
    })
      .catch((error) => {
        reject(error);
      });
  });
}

function postCheckCodeAndGetGift(reqData) {
  reqData.gid = app.tip_gid || ConfigInfo.instance.getTipGid();
  return new Promise((resolve, reject) => {
    post({
      reqData,
      showMsgToast: true,
      url: '/merc.merccgi.acts.acts/CheckCodeAndGetGift',
    }).then((response) => {
      resolve(response);
    })
      .catch((error) => {
        reject(error);
      });
  });
}

function postExecCloseWindow() {
  const reqData = {};
  reqData.gid = app.tip_gid || ConfigInfo.instance.getTipGid();
  return new Promise((resolve, reject) => {
    post({
      reqData,
      showMsgToast: false,
      url: '/merc.merccgi.acts.acts/ExecCloseWindow',
    }).then((response) => {
      resolve(response);
    })
      .catch((error) => {
        reject(error);
      });
  });
}

export default {
  postGetBindRelation,
  postSetBindRelation,
  postGetBindToken,
  postSetUserAndBrandRelation,
  postUpdateUserPhone,
  postSendTelMsgCode,
  postSendTelMsgCodeWithWaterProof,
  postGetLottCondAndWritting,
  postCheckCodeAndGetGift,
  postExecCloseWindow,
};
export {
  postGetBindRelation,
  postSetBindRelation,
  postGetBindToken,
  postSetUserAndBrandRelation,
  postUpdateUserPhone,
  postSendTelMsgCode,
  postSendTelMsgCodeWithWaterProof,
  postGetLottCondAndWritting,
  postCheckCodeAndGetGift,
  postExecCloseWindow,
};
